import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { Button, ShortcutLink, WContainer, WImage } from '@next-nx/shared-ui/atoms'
import { useTealium } from '@next-nx/hooks';
import { getTimestamp } from '@next-nx/utils';
import styles from './FaqHome.module.sass'

interface Props {
  item?: MenuItemType
  boxItem?: MenuItemType
  bgVariant?: '' | 'lightblue'
  hideBoxOnMobile?: boolean
  className?: string
}

const FaqHome = (props: Props) => {

  const { 
    item = undefined,
    boxItem = undefined,
    bgVariant = '',
    hideBoxOnMobile = false,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, faq_category?: string, faq_title?: string, cta?: string) => {
    const action_timestamp = getTimestamp()
    let dlObj = {}

    switch (action_type?.replace(/ /g, '_').toLowerCase()) {
      case 'consulta_faq':
        faq_category = faq_title?.includes('manutenzione') ? 'manutenzione' : faq_title?.includes('assicurativi') ? 'assicurazione' : 'assistenza'
        dlObj = {
          virtual: 'action',
          action_name: 'navigazione', 
          action_tech: 'click',
          action_type,
          action_timestamp,
          action_effect: 'interazione_componente_faq',
          faq_category: faq_category?.replace(/ /g, '_').replace(/,/g, '').toLowerCase(),
          faq_title: faq_title?.replace(/ /g, '_').replace(/,/g, '').replace(/\./g, '').toLowerCase(),
        }
        break;
      case 'visita_la_sezione_faq':
      case 'vai_alle_faq':
      case 'vai_in_agenzia':
        dlObj = {
          virtual: "action",
          action_name: "navigazione", 
          action_tech: "click",
          action_type: action_type?.replace(/ /g, '_').toLowerCase(),
          action_timestamp,
          action_effect: "interazione_componente_faq"
        }
        break;
      default:
        dlObj = {
          virtual: 'action',
          action_name: 'contattaci',
          action_tech: 'click',
          action_type: 'accedi',
          action_timestamp,
          action_effect: 'accesso_pagina_contatti',
        }
        cta = cta?.trim() === "Trova un'agenzia" ? 'vai_in_agenzia' : cta
        linkDataLayer({
          virtual: "action",
          action_name: "navigazione", 
          action_tech: "click",
          action_type: cta?.replace(/ /g, '_').toLowerCase(),
          action_timestamp,
          action_effect: "interazione_componente_contatti"
        })
        break;
    }
    linkDataLayer(dlObj)
  }

  return item ? (
    <div className={`${styles.root} ${bgVariant ? styles[`root--${bgVariant}`] : ''} ${hideBoxOnMobile ? styles['root--hideBoxOnMobile'] : ''} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.content}>
            <p className={styles.title}>{item.name}</p>
            <div className={styles.list}>
              {item.children?.edges?.map(x => x.node).map(x => (
                <ShortcutLink itemName={x.name} itemUrl={x.url} key={x.pk} colorVariant={bgVariant === 'lightblue' ? 'white' : undefined} handleTracking={handleTracking} sezione='consulta_faq' />
              ))}
            </div>
            {!!item.ctaLabel && !!item.url && (
              <div className={styles.ctaBox}>
                <Button label={item.ctaLabel} href={item.url} newPage={item.blank} icon={<ArrowRight />} handleTracking={() => handleTracking('visita_la_sezione_faq')} iconPos="right" variant="ghost" />
              </div>
            )}
          </div>
          <div className={styles.box}>
            {boxItem && (
              <div className={styles.boxContent}>
                <p className={styles.boxTitle}>{boxItem.name}</p>
                {!!boxItem.children?.edges?.length && (
                  <div className={styles.boxCtaBox}>
                    {boxItem.children?.edges?.map(x => x.node).map((x, i) => (
                      <div key={x.pk}>
                        <Button 
                          label={x.ctaLabel}
                          href={x.url}
                          variant={x.style === 'secondary' ? x.style : i % 2 === 0 ? 'primary' : 'ghost'} 
                          color={x.style === 'secondary' ? 'white' : i % 2 === 0 ? 'default' : 'white'}
                          icon={i % 2 === 0 ? undefined : <ArrowRight />}
                          iconPos="right"
                          handleTracking={(ty, c, t, cta) => handleTracking(cta)}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {boxItem?.image && (
            <div className={styles.imageBox}>
              <WImage
                src={boxItem.image}
                alt={boxItem.name}
                title={boxItem.name}
                maxWidth={492}
                maxHeight={531}
                layout="fill"
                objectFit='cover'
              />
            </div>
            )}
          </div>
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default FaqHome
